import { render, staticRenderFns } from "./WebsiteSettingsInput.vue?vue&type=template&id=365167e0&scoped=true&"
import script from "./WebsiteSettingsInput.vue?vue&type=script&lang=js&"
export * from "./WebsiteSettingsInput.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteSettingsInput.vue?vue&type=style&index=0&id=365167e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365167e0",
  null
  
)

export default component.exports